import { Module } from 'vuex'
import { DocumentCounts } from '@/utils/types/document'
import { documentCounts as documentCountsRequest } from '@/requests/document'

const documentCounts: Module<DocumentCounts, any> = {
  namespaced: true,
  state() {
    return {
      isMe: null,
      draft: null,
      inProgress: null,
      revision: null,
      onRegistration: null,
      registered: null,
      signingToday: null,
      signingOverdue: null,
      signingApproaching: null,
      approvalToday: null,
      approvalOverdue: null,
      approvalApproaching: null,
      review: null,
      pendingAcknowledgment: null,
      acceptedAcknowledgment: null,
    }
  },
  mutations: {
    setDocumentCounts(state, payload: DocumentCounts) {
      Object.assign(state, payload)
    },
    setDocumentCount(
      state,
      payload: {
        key: keyof DocumentCounts
        value: number
      }
    ) {
      state[payload.key] = payload.value
    },
  },
  actions: {
    async getDocumentCounts({ commit }) {
      const counts = await documentCountsRequest()

      commit('setDocumentCounts', counts)
    },
  },
}

export { documentCounts }
